export class PluginModel {
  id: number;
  action: string;
  data: any;
  target: string;
  queryParams: any;
}
